import * as React from "react";

import { cn } from "@/lib/utils";

/** Display an available key. The owning control supplies its behavior. */
function Kbd({ className, ...props }: React.ComponentProps<"kbd">) {
  return (
    <kbd
      data-slot="kbd"
      className={cn(
        "inline-flex min-h-5 min-w-5 items-center justify-center rounded-xs border border-border-strong bg-secondary px-1 font-mono text-key font-medium text-muted-foreground",
        className,
      )}
      {...props}
    />
  );
}

export { Kbd };
